
// eslint-disable-next-line import/prefer-default-export
export const OKTA_TOKEN_STORAGE = 'okta-token-storage';

export const PAGE_SIZE = 500;
